import { defineMessages } from 'react-intl';

type MessageKeys = 'favouritesSectionTitle' | 'myAgentsSectionTitle';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		favouritesSectionTitle: {
			id: 'browse-agents.agents-list-fullscreen.favourites-section-title',
			defaultMessage: 'Favorites',
			description: 'Title of the favourites section in the agents list fullscreen',
		},
		myAgentsSectionTitle: {
			id: 'browse-agents.agents-list-fullscreen.my-agents-section-title',
			defaultMessage: 'My agents',
			description: 'Title of the my agents section in the agents list fullscreen',
		},
	});

export default message;
